// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    apiUrl: "https://testapi.vaquita.health",
    sseUrl: "https://testsse.vaquita.health",

    // Formato .txt sin cifrar

    nomExportFormat: "txt",
    openPay:{
      pk:"pk_2f062b7853104e7191be9bd0828dee7e",
      id:"mohjysj3t1ogn8lotmi1",
      sandbox: true
    },
    stripe:{
      key:"pk_test_51SakKqIdAHCEsBeEOMbIlSeNTgxkveQzAbSxsEmZOMVP2BzSg5splAnqpyjJFwuLDtFKhM1o3naL2JKJFY2yRAOa004J4Ro5Cs"
    }
  };
   
  